const fonts = {
  heading: 'Noto Sans TC, sans-serif',
  body: 'Noto Sans TC, sans-serif',
};

export default fonts;
